import { styled } from '@mui/material';

export const RelevantServiceWrap = styled('div')<{ isMediumScreen?: boolean }>(
  ({ isMediumScreen = false }) => ({
    padding: isMediumScreen ? '16px 0px' : '56px 0px',
    backgroundColor: 'var(--color-background-secondary)',

    '& img': {
      pointerEvents: 'none',
      WebkitUserDrag: 'none',
      userDrag: 'none',
    },
  })
);
